/**
 * Reload a screen after a failed action, THEN report the failure.
 *
 * Every Accesos page's `refresh()` starts with `setError(null)`, so an
 * error set before awaiting it is wiped (batched away before it ever
 * renders). The action's own message goes on AFTER the reload, and an
 * error the reload itself produced is kept beside it, not replaced.
 */
export async function reloadThenReport(
  message: string,
  refresh: () => Promise<void>,
  setError: (update: (prev: string | null) => string | null) => void,
): Promise<void> {
  await refresh();
  setError((prev) => (prev === null ? message : `${message}\n${prev}`));
}
